import React from 'react';
import Header from './Header';
import Footer from './Footer/Footer';
import ContextUpdater from '../context-updater';
import CookiesBanner from '../Global/CookiesBanner/CookiesBanner';
import useRegionSelector from '../../hooks/useRegionSelector';
import {
  FACEBOOK_IG_PIXEL_SCRIPT,
  FACEBOOK_IG_PIXEL_ID_UK,
  FACEBOOK_IG_PIXEL_ID_EU,
  TWITTER_PIXEL_SCRIPT,
  TWITTER_PIXEL_ID_UK,
  TWITTER_PIXEL_ID_EU,
  LINKEDIN_PIXEL_SCRIPT,
  LINKEDIN_PIXEL_ID,
  TIKTOK_PIXEL_SCRIPT,
  TIKTOK_PIXEL_ID,
  FACEBOOK_IG_PIXEL_NO_SCRIPT,
  LINKEDIN_PIXEL_NO_SCRIPT,
} from '../../utils/pixels';
import { Helmet } from 'react-helmet';
import Alert from '../Global/Alert/Alert';

import '../../styles/main.scss';

function Layout({ children }) {
  const { region } = useRegionSelector() || { region: 'GLOBAL' };
  const currentRegion = region || 'GLOBAL';

  const REGION_SCRIPTS_ID = {
    UK: {
      FACEBOOK_IG: FACEBOOK_IG_PIXEL_ID_UK,
      TWITTER: TWITTER_PIXEL_ID_UK,
    },
    EU: {
      FACEBOOK_IG: FACEBOOK_IG_PIXEL_ID_EU,
      TWITTER: TWITTER_PIXEL_ID_EU,
      LINKEDIN: LINKEDIN_PIXEL_ID, // Only for EU
      TIKTOK: TIKTOK_PIXEL_ID, // Only for EU
    },
    GLOBAL: {
      FACEBOOK_IG: '',
      TWITTER: '',
      LINKEDIN: '',
      TIKTOK: '',
    },
  };

  return (
    <>
      <Helmet>
        {/* Facebook */}
        <script id="facebook-pixel-script">
          {FACEBOOK_IG_PIXEL_SCRIPT(REGION_SCRIPTS_ID[currentRegion].FACEBOOK_IG)}
        </script>
        <noscript id="facebook-pixel-image">
          {FACEBOOK_IG_PIXEL_NO_SCRIPT(REGION_SCRIPTS_ID[currentRegion].FACEBOOK_IG)}
        </noscript>

        {/* Twitter/X */}
        <script id="twitter-pixel-script">{TWITTER_PIXEL_SCRIPT(REGION_SCRIPTS_ID[currentRegion].TWITTER)}</script>

        {/* Linkedin */}
        {currentRegion === 'EU' && (
          <script id="linkedin-pixel-script">{LINKEDIN_PIXEL_SCRIPT(REGION_SCRIPTS_ID[currentRegion].LINKEDIN)}</script>
        )}
        {currentRegion === 'EU' && (
          <noscript id="linkedin-pixel-image">
            {LINKEDIN_PIXEL_NO_SCRIPT(REGION_SCRIPTS_ID[currentRegion].LINKEDIN)}
          </noscript>
        )}

        {/* TikTok */}
        {/* {currentRegion === 'EU' && (
          <script id="tiktok-pixel-script">{TIKTOK_PIXEL_SCRIPT(REGION_SCRIPTS_ID[currentRegion].TIKTOK)}</script>
        )} */}
      </Helmet>

      <ContextUpdater />
      <CookiesBanner />
      <Alert />

      <Header />
      <main className={`main-content`}>{children}</main>
      <Footer />
    </>
  );
}

export default Layout;
